
$("input[type='number']").inputSpinner();

$('.open-basket-shop').click(function (e){
    e.preventDefault();
    $('.cart-content').addClass('open');
});
$('.close-cart, .btn-cart-continua').click(function (e){
    e.preventDefault();
    $('.cart-content').removeClass('open');
});
$(document).on('click','.btn-cta-checkout.disabled',function (e){
    console.log('disattivato');
    e.preventDefault();
});
$('.overlay-cart').on('click', function(e) {
    if (e.target !== this)
        return;
    $('.cart-content').removeClass('open');
});

/*
* Controllo form login utente
* */
if($("#form-login-user").length>0) {
    $("#form-login-user").validate({
        rules: {
            email: {
                required: true,
                email: true
            },
            password: {
                required: true
            },
        }
    });
}

/*
* Controllo form modifica password
* */
if($("#form-edit-psw").length>0) {
    $("#form-edit-psw").validate({
        rules: {
            password: {
                required: true
            },
            password_confirmation: {
                equalTo: "#password",
            }
        }
    });
}

/*
* Controllo form recupero password
* */
if($("#form-email-recupero").length>0) {
    $("#form-email-recupero").validate({
        rules: {
            email: {
                required: true,
                email: true
            },
        }
    });
}

/*
* Controllo form registrazione utente
* */
if($(".register-form").length>0) {
    $(".register-form form").validate({
        rules: {
            email: {
                required: true,
                email: true
            },
            first_name: {
                required: true
            },
            last_name: {
                required: true
            },
            fiscal_code: {
                required: true
            },
            company_name: {
                required: "#type_user_c:checked"
            },
            pec:{
                pec_sdi: true
            },
            sdi:{
                pec_sdi:true
            },
            country_id: {
                required: true
            },
            city_id: {
                required: true
            },
            city: {
                required: true
            },
            postal_code: {
                required: true
            },
            address: {
                required: true
            },
            telephone: {
                required: true
            },
            shipment_first_name: {
                required: "input[name='new_address']:checked"
            },
            shipment_last_name: {
                required: "input[name='new_address']:checked"
            },
            shipment_country_id: {
                required: "input[name='new_address']:checked"
            },
            shipment_city_id: {
                required: "input[name='new_address']:checked"
            },
            shipment_postal_code: {
                required: "input[name='new_address']:checked"
            },
            shipment_city: {
                required: "input[name='new_address']:checked"
            },
            shipment_address: {
                required: "input[name='new_address']:checked"
            },
            shipment_telephone: {
                required: "input[name='new_address']:checked"
            },
            payment_method_id: {
                required: true
            },
            password: {
                minlength: 8
            },
            password_confirmation: {
                equalTo: "#password",
                minlength: 8
            },
            privacy: {
                required: true
            }
        },
        messages: {
            pec: message.field,
            sdi: message.field,
            payment_method_id: message.payment
        }
    });
}
$.validator.addMethod("pec_sdi", function(value, element){
    /*console.log('pec valida: '+$("#pec").val()!='' && $('#type_user_c').is(':checked'));
    console.log('sdi valido: '+$("#sdi").val()!='' && $('#type_user_c').is(':checked'));*/
    if(($("#pec").val()!='' && $('#type_user_c').is(':checked')) || ($("#sdi").val()!='' && $('#type_user_c').is(':checked')) && $('#country_id').val()=='105'){
        //console.log('valido');
        $('#pec-error').hide();
        $('#sdi-error').hide();
        return true;
    }else{
        if($('#type_user_c').is(':checked')){
            console.log('non valido');
            $('#pec-error').show();
            $('#sdi-error').show();
            return false;
        }else{
            return true
        }
    }
});
if($(".content-checkout").length>0) {
    /*
    * Controllo form checkout login
    * */
    $(".form-login-cart form").validate({
        rules: {
            email: {
                required: true,
                email: true
            },
            password: {
                required: true
            },
        }
    });

    /*
    * Controllo form checkout
    * */

    /*$(".content-checkout #form-register-checkout").validate({
        rules: {
            email_guest: {
                required: true,
                email: true
            },
            new_psw: {
                required: "input[name='new_account']:checked",
                minlength: 8
            },
            first_name: {
                required: true
            },
            last_name: {
                required: true
            },
            fiscal_code: {
                required: true
            },
            company_name: {
                required: "#type_user_c:checked"
            },
            pec:{
                pec_sdi: true
            },
            sdi:{
                pec_sdi:true
            },
            country_id: {
                required: true
            },
            city_id: {
                required: true
            },
            city: {
                required: true
            },
            postal_code: {
                required: true
            },
            address: {
                required: true
            },
            telephone: {
                required: true
            },
            shipment_first_name: {
                required: "input[name='new_address']:checked"
            },
            shipment_last_name: {
                required: "input[name='new_address']:checked"
            },
            shipment_country_id: {
                required: "input[name='new_address']:checked"
            },
            shipment_city_id: {
                required: "input[name='new_address']:checked"
            },
            shipment_postal_code: {
                required: "input[name='new_address']:checked"
            },
            shipment_city: {
                required: "input[name='new_address']:checked"
            },
            shipment_address: {
                required: "input[name='new_address']:checked"
            },
            shipment_telephone: {
                required: "input[name='new_address']:checked"
            },
            payment_method_id: {
                required: true
            },
            privacy: {
                required: true
            }
        },
        messages: {
            pec: message.field,
            sdi: message.field,
            payment_method_id: message.payment
        }
    });
    var form_checkout = $( "#form-register-checkout" );
    $(".btn-payorder").click(function() {
        if( form_checkout.valid() == true){
            $(".btn-payorder").hide();
        }else{
            $(".btn-payorder").show();
        }
    });*/
}

/*
* Controllo form modifica profilo
* */
if($("#form-edit-profile").length>0) {
    $("#form-edit-profile").validate({
        rules: {
            email: {
                required: true,
                email: true
            },
            first_name: {
                required: true
            },
            last_name: {
                required: true
            },
            company_name: {
                required: "#type_user_c:checked"
            },
            password: {
                minlength: 8
            },
            password_confirmation: {
                equalTo: "#password",
                minlength: 8
            },
            privacy: {
                required: true
            }
        }
    });
}

var Sticky = require('sticky-js/src/sticky');
var stickySidebar = new Sticky('.simple-sidebar');
